import { useQuery, useQueryClient, QueryOptions, QueryResult } from '@eika-infrastruktur/react-query';

import type { AccountId, LoanRepaymentPlan } from '../generated-types';
import { getLoanRepaymentPlan } from '../services/loanService';

const LOAN_REPAYMENT_PLAN_KEY = 'loanRepaymentPlan';

const useLoanRepaymentPlan = (
    accountId?: AccountId,
    options: Partial<QueryOptions<LoanRepaymentPlan>> = {},
): QueryResult<LoanRepaymentPlan> =>
    useQuery({
        ...options,
        queryKey: [LOAN_REPAYMENT_PLAN_KEY, accountId],
        queryFn: () => getLoanRepaymentPlan(accountId!),
        enabled: !!accountId,
        staleTime: Infinity,
    });

export const useRefreshLoanRepaymentPlan = () => {
    const queryClient = useQueryClient();

    return (accountId?: AccountId) => {
        return queryClient.invalidateQueries({
            queryKey: [LOAN_REPAYMENT_PLAN_KEY, accountId],
        });
    };
};

export default useLoanRepaymentPlan;
